export const quranEn = {
  landing: {
    badge: 'The Quran is now open to everyone',
    titleLine1: 'The Quran, for everyone.',
    titleGradient: 'Read. Listen. Study.',
    subtitle:
      'The whole Quran in Arabic with English and Bosnian translation. Free, no sign-up, on any device. Search a word, count it across the whole Quran, and listen ayah by ayah.',
    appNote: 'For hifz with AI, offline audio and prayer times, get the app.',
    daily: 'Ayah of the day',
    listen: 'Listen',
    study: 'Study this ayah',
    studyEyebrow: 'The Quran on Deenly',
    studyTitle: 'Don’t just read. Study.',
    studySubtitle: 'Tools that help you understand what you read, free for everyone.',
    cards: [
      { to: '/quran/', icon: 'solar:book-2-linear', title: 'Read and listen', body: 'All 114 surahs, the Arabic text and two translations, six reciters. The player follows the recited ayah, even from the lock screen.', cta: 'Open the Quran' },
      { to: '/quran/tafsir/', icon: 'solar:notebook-bookmark-linear', title: 'Tafsir of every ayah', body: 'What does an ayah mean? An explanation of all 6,236 ayat from Al-Mukhtasar, in English and the Arabic original, with its source and a citation.', cta: 'Open the tafsir' },
      { to: '/quran/search/', icon: 'solar:magnifer-linear', title: 'Search by word or meaning', body: 'Find an ayah by a word, a surah name or a reference like 2:255. Or describe a theme and AI finds ayat by meaning.', cta: 'Search the Quran' },
      { to: '/quran/2/255/', icon: 'solar:square-academic-cap-linear', title: 'Word by word', body: 'Tap any Arabic word: its root, its grammar and how often it occurs in the Quran. From the root, follow one idea through the whole Quran.', cta: 'Try it on Ayat al-Kursi' },
    ],
  },
  nav: {
    home: 'Deenly home',
    quran: 'Quran',
    label: 'Quran navigation',
    read: 'Read',
    search: 'Search',
    words: 'Quran in numbers',
    tafsir: 'Tafsir',
    roots: 'Roots',
    chronology: 'Chronology',
    switchLanguage: 'Prebaci na bosanski',
  },
  common: {
    close: 'Close',
    error: 'Something went wrong. Please try again in a moment.',
    notFound: 'This ayah does not exist.',
    breadcrumbs: 'Breadcrumbs',
    pagination: 'Previous and next',
    loadMore: 'Load more',
  },
  translation: {
    de: 'German · Bubenheim & Elyas',
    nl: 'Dutch · Rowwad Translation Center',
    fr: 'French · Rachid Maach',
    bs: 'Bosnian · Besim Korkut',
    en: 'English · Saheeh International',
  },
  quick: {
    label: 'Most read',
    ayatulKursi: 'Ayat al-Kursi',
    lastOfBaqarah: 'End of Al-Baqarah',
  },
  index: {
    badge: 'Open to everyone · free · no sign-up',
    title: 'The Quran, for everyone',
    subtitle:
      'All 114 surahs in Arabic with English and Bosnian translation. Listen ayah by ayah, search by word or by meaning, and study every word.',
    stats: [
      { label: 'Surahs', value: '114' },
      { label: 'Ayat', value: '6,236' },
      { label: 'Languages', value: '3' },
      { label: 'Reciters', value: '6' },
    ],
    wordsTitle: 'How many times does the Quran say…?',
    wordsBody:
      'Type any word (in Arabic, English or Bosnian) and see in a second how often it occurs, in which surahs and ayat. Compare two words and see the Quran from a new angle.',
    wordsCta: 'Open Quran in numbers',
    surahsTitle: 'All surahs',
    surahsSubtitle: 'Find one by name, meaning or number.',
    filterLabel: 'Filter surahs',
    filterPlaceholder: 'e.g. Yasin, The Cave, 18…',
    filterRevelation: 'Place of revelation',
    filterAll: 'All',
    noMatch: 'No surah matches.',
  },
  surah: {
    meccan: 'Meccan',
    medinan: 'Medinan',
    ayahCount: '{n} ayah | {n} ayat',
    juz: 'Juz {n}',
    listen: 'Listen to the surah',
    previous: 'Previous surah',
    next: 'Next surah',
  },
  ayah: {
    actions: 'Actions for {ref}',
    listen: 'Listen to {ref}',
    copy: 'Copy ayah',
    save: 'Save to my study room',
    saved: 'Saved to your collection',
    copied: 'Copied',
    share: 'Share',
    study: 'Study {ref}',
    sajdah: 'Sajdah',
  },
  ayahPage: {
    eyebrow: 'Ayah',
    inContext: 'Read in context',
    listenOn: 'Listen from here',
    previous: 'Previous ayah',
    next: 'Next ayah',
    wordsTitle: 'Word by word',
    wordsHint: 'Every word of the ayah with its pronunciation and meaning. Tap a word to see how often it occurs in the Quran.',
    wordsSource: 'Pronunciation and word meanings: Quran.com.',
    wordsSourceBs: 'Pronunciation and word meanings: Quran.com.',
    relatedTitle: 'Related ayat',
    relatedHint: 'Ayat elsewhere in the Quran that speak about the same theme.',
    aboutSurah: 'About this surah',
  },
  settings: {
    title: 'Settings',
    translation: 'Translation',
    both: 'Both',
    none: 'None',
    arabicFont: 'Arabic script',
    arabicSize: 'Arabic text size',
    sizeStep: 'Size {n}',
    wordStudy: 'Word study',
    wordStudyHint: 'Tap an Arabic word to see how often it occurs in the Quran.',
  },
  player: {
    label: 'Quran player',
    play: 'Play',
    pause: 'Pause',
    previous: 'Previous ayah',
    next: 'Next ayah',
    stop: 'Stop and close',
    expand: 'Open player',
    collapse: 'Minimise player',
    nowPlaying: 'Now reciting',
    openSurah: 'Open surah',
    seek: 'Position in the ayah',
    failed: 'The audio did not load. Check your connection and try again.',
    reciter: 'Reciter',
    repeatAll: 'Repeat all',
    ayahRepeat: 'Repeat each ayah: {n}',
    repeatRound: 'time {n}',
    volume: 'Volume',
    sleep: 'Sleep timer',
    sleepMinutes: 'In {n} minutes',
    sleepEnd: 'At the end of the surah',
    sleepOff: 'Turn the timer off',
    tabText: 'Text',
    ayahOf: 'ayah {ayah} of {total}',
    backToCurrent: 'Back to the recited ayah',
    speed: 'Speed',
    follow: 'Follow the recitation',
    followHint: 'While a surah plays, the page scrolls itself to the ayah being recited and marks it.',
  },
  peek: {
    title: 'The word {word} in the Quran',
    eyebrow: 'This word in the Quran',
    exact: 'Exactly this form',
    inside: 'Inside other words',
    spread: 'In {ayahs} ayat, across {surahs} surahs.',
    open: 'Every occurrence',
  },
  tafsir: {
    nav: 'Tafsir',
    cta: 'Open the tafsir',
    teaser: 'What does an ayah mean? An explanation of every ayah from Al-Mukhtasar, in English, French, Bosnian and the Arabic original, with its source and a citation for your study.',
    eyebrow: 'Explaining the Quran',
    title: 'Tafsir of the Quran',
    intro:
      'An explanation of every one of the 6,236 ayat from Al-Mukhtasar, in English, French, Bosnian and the original Arabic. Read the tafsir surah by surah, compare it with the original and search what is said about any theme.',
    facts: { ayahs: 'ayat explained', langs: 'languages: English, French, Dutch, Bosnian, Arabic', surahs: 'surahs' },
    surahsTitle: 'Tafsir by surah',
    surahsHint: 'Pick a surah: every ayah in Arabic, with its translation and the explanation beneath it.',
    aboutTitle: 'About Al-Mukhtasar',
    about: [
      'Al-Mukhtasar in Interpreting the Noble Quran was prepared by the Tafsir Center for Quranic Studies. Each ayah is explained briefly and clearly, without long digressions, which suits both daily reading and serious study.',
      'It was written in Arabic; the English, French and Bosnian texts are translations of that original. That is why every ayah lets you open the Arabic original and compare it with the translation.',
    ],
    methodTitle: 'How it is published here',
    method: [
      'The text is published exactly as issued by the source, without changes or cuts.',
      'Every text names its title, author, edition and the date it was retrieved, and the “Cite” button gives a ready citation with a link.',
      'The tafsir is kept in line with the latest version published by QuranEnc.com.',
    ],
    langLabel: 'Tafsir language',
    langs: { bs: 'Bosanski', en: 'English', fr: 'Français', nl: 'Nederlands', ar: 'العربية' },
    sameAs: 'See the explanation of ayah {n}.',
    retold: 'A modern retelling based on the classical scholars, not a word-for-word translation',
    translationOf: 'Translated from the Arabic original',
    original: 'Arabic original',
    label: 'Tafsir',
    ayahTitle: 'Tafsir of this ayah',
    ayahHint: 'What this ayah means: the explanation from Al-Mukhtasar.',
    wholeSurah: 'Tafsir of the whole surah',
    readSurah: 'Read the surah',
    show: 'Tafsir',
    hide: 'Hide tafsir',
    toggle: 'Tafsir of {ref}',
    inReader: 'Tafsir under every ayah',
    inReaderHint: 'A short explanation beneath each ayah. The “Tafsir” button on an ayah opens it one at a time.',
    showAyah: 'Ayah and translation',
    ayahIndex: 'Ayat',
    goToAyah: 'Go to ayah {n}',
    source: 'Source',
    sourceLine: '{title} — {author}. {publisher}, edition “{edition}”, retrieved {date}.',
    cite: 'Cite',
    cited: 'Citation copied',
    refAyah: 'of ayah {key}',
    refSurah: 'of Surah {name}',
    citation: '{title} ({author}), explanation {ref}. {publisher}, edition “{edition}”, retrieved {date}. {url}',
    unavailable: 'The tafsir is not available in this language yet.',
    searchTitle: 'Search the tafsir',
    searchLabel: 'Search the tafsir',
    searchPlaceholder: 'A theme or word, e.g. patience, parents, Day of Judgement',
    searchHint: 'Searches the explanations, not just the ayat: find what the tafsir says about a theme.',
    resultCount: 'No ayah has “{q}” in its tafsir | {n} ayah has “{q}” in its tafsir | {n} ayat have “{q}” in their tafsir',
    previous: 'Previous surah',
    next: 'Next surah',
  },
  opinions: {
    title: "What the scholars said",
    searchHint: "Answers of Ahl as-Sunnah scholars, found by words and by meaning, each linked to its source.",
    ayahHint: "Answers that cite this ayah.",
    none: "No answer found.",
    scholars: "Scholars",
    citedAyat: "Ayat cited:",
    source: "Read at the source: {source}",
    inLanguage: "Available in: {language}",
  },
  search: {
    title: 'Search the Quran',
    label: 'Search the Quran',
    placeholder: 'A word, surah or ayah (e.g. mercy, Yasin, 2:255)',
    submit: 'Search',
    suggestions: 'Suggestions',
    jump: 'Go to ayah {ref}',
    allResults: 'All results for “{q}”',
    countWord: 'How many times is “{q}” mentioned?',
    modeLabel: 'Search mode',
    byWords: 'By words',
    byMeaning: 'By meaning',
    byScholars: "By scholars",
    byTafsir: 'In the tafsir',
    meaningHint: 'Describe a theme in your own words, e.g. “ayat about patience in hardship”. AI finds ayat by meaning, not by keyword.',
    meaningTooShort: 'Type at least three letters.',
    meaningError: 'Search by meaning is unavailable right now. Try searching by words.',
    resultCount: 'No ayat for “{q}” | {n} ayah for “{q}” | {n} ayat for “{q}”',
    took: '{ms} ms',
    aiLabel: 'Artificial intelligence',
    aiWorking: 'AI is searching the Quran by meaning…',
    aiFound: 'AI found no ayah for this question | AI found {n} ayah by meaning | AI found {n} ayat by meaning',
    emptyTitle: 'What you can search',
    tips: [
      'A word in English, Bosnian or Arabic: mercy, milost, رحمة',
      'A surah name: Kahf, Yasin, Rahman',
      'An exact ayah: 2:255 or 36 1',
      'A theme by meaning: switch to “By meaning”',
    ],
  },
  words: {
    title: 'The Quran in numbers',
    subtitle:
      'How many times does a word occur in the Quran, in which surahs, Meccan or Medinan? Type a word, or compare two, in one click.',
    tryOne: 'Try an example:',
    examples: 'Examples',
    inputLabel: 'Word to count',
    placeholder: 'A word (e.g. mercy, الله, milost)',
    compareLabel: 'Word to compare',
    comparePlaceholder: 'A second word to compare',
    wordA: 'First word',
    wordB: 'Second word',
    addCompare: 'Compare with another word',
    removeCompare: 'Remove comparison',
    count: 'Count',
    langLabel: 'Text language',
    langBs: 'Bosnian',
    langEn: 'English',
    arabicDetected: 'Counting in the Arabic text',
    modeLabel: 'How a word matches',
    modeWord: 'Whole word',
    modePrefix: 'Starts with',
    modeContains: 'Contains',
    modeHint: {
      word: 'Counts exactly that word: “day” does not count “days”.',
      prefix: 'Counts every word that starts with it: “merc” counts mercy, merciful, mercies…',
      contains: 'Counts words that contain it: Arabic “الله” also counts “والله”, “بالله”…',
    },
    occurrences: '{n} time | {n} times',
    inAyahs: 'in {ayahs} ayat, {surahs} surahs',
    revelationSplit: 'Meccan surahs {meccan}%, Medinan {medinan}%',
    firstSeen: 'First',
    lastSeen: 'Last',
    topSurahs: 'Most in',
    equal: '“{a}” and “{b}” are mentioned equally, {n} times each.',
    nearlyEqual: '“{a}” and “{b}” are mentioned almost equally: {x} and {y} times.',
    ratio: '“{more}” is mentioned {ratio}× as often as “{less}”.',
    chartTitle: 'Across the 114 surahs',
    chartHint: 'One column per surah, in mushaf order. Click one for details.',
    chartLabel: 'Occurrences per surah',
    chartCaption: 'Column chart: one column for each of the 114 surahs; height is the number of occurrences.',
    openSurah: 'Open surah',
    noneTitle: 'No occurrences',
    noneBody: 'Translations often put the same idea in other words. Try “Starts with” or “Contains”, a synonym, or the Arabic word, since the Arabic text is authoritative.',
    ayahsTitle: 'Ayat',
    method:
      'We count word forms in the text, without vowel marks. The Arabic text is authoritative; translations use different words for the same idea, so their counts differ from the Arabic.',
  },
  grammar: {
    title: 'Grammar',
    root: 'Root',
    lemma: 'Dictionary form',
    parts: 'Parts of the word',
    noRoot: 'Particles and pronouns have no root.',
    rootCount: '{n}× in the Quran',
    allOfRoot: 'Every word of this root',
    person: '{n}{suffix} person',
    gender: { M: 'masculine', F: 'feminine' },
    number: { S: 'singular', D: 'dual', P: 'plural' },
    form: 'verb form {n}',
    passive: 'passive',
    definite: 'definite (with ٱل)',
    indefinite: 'indefinite',
    family: 'of the “{word}” family',
    tense: { PERF: 'perfect (past)', IMPF: 'imperfect (present/future)', IMPV: 'imperative' },
    case: { NOM: 'nominative', ACC: 'accusative', GEN: 'genitive' },
    mood: { IND: 'indicative', SUBJ: 'subjunctive', JUS: 'jussive' },
    class: {
      V: 'verb',
      N: 'noun',
      PN: 'proper noun',
      ADJ: 'adjective',
      ACT_PCPL: 'active participle',
      PASS_PCPL: 'passive participle',
      VN: 'verbal noun (masdar)',
      PRON: 'pronoun',
      DEM: 'demonstrative pronoun',
      REL: 'relative pronoun',
      T: 'time adverb',
      LOC: 'location adverb',
      NV: 'verbal interjection',
      P: 'particle',
    },
    particle: {
      DET: 'definite article',
      CONJ: 'conjunction',
      REM: 'resumption particle',
      P: 'preposition',
      NEG: 'negative particle',
      EMPH: 'emphatic particle',
      INTG: 'interrogative particle',
      VOC: 'vocative particle',
      FUT: 'future particle',
      CERT: 'particle of certainty',
      RSLT: 'result particle',
      CAUS: 'particle of cause',
      SUB: 'subordinating conjunction',
      COND: 'conditional particle',
      RES: 'restriction particle',
      PRP: 'particle of purpose',
      CIRC: 'circumstantial particle',
      EXP: 'exceptive particle',
      PREV: 'preventive particle',
      PRO: 'prohibition particle',
      RET: 'retraction particle',
      SUP: 'supplemental particle',
      SUR: 'surprise particle',
      EXH: 'exhortation particle',
      EXL: 'explanation particle',
      EQ: 'equalization particle',
      AMD: 'amendment particle',
      ANS: 'answer particle',
      AVR: 'aversion particle',
      COM: 'comitative particle',
      INC: 'inceptive particle',
      INT: 'particle of interpretation',
      INL: 'Quranic initials',
      ATT: 'attention particle',
      DIST: 'distance marker',
      ADDR: 'addressee marker',
      ACC: 'accusative particle',
    },
  },
  roots: {
    nav: 'Roots',
    eyebrow: 'The Quran’s vocabulary',
    title: 'The roots of Quranic words',
    subtitle:
      'Almost every Arabic word grows from a root of three or four letters: the root صبر gives patience, patient and to be patient. Pick a root and follow one idea through the whole Quran.',
    factRoots: 'roots',
    factLemmas: 'dictionary forms',
    factWords: 'words with their grammar',
    lettersLabel: 'Roots by first letter',
    searchLabel: 'Search the roots',
    searchPlaceholder: 'A root or a meaning (e.g. رحم, knowledge, mercy)',
    count: '{n} roots',
    showing: 'Showing {shown} of {total}',
    none: 'No root matches your search.',
    showMore: 'Show more',
    sortLabel: 'Sort',
    sortFrequent: 'Most frequent',
    sortAlpha: 'Alphabetical',
    occurrences: '{n}× in the Quran',
    words: '{n} word | {n} words',
    pageTitle: 'The root {root}',
    pageSubtitle: 'Every word built from this root, where it occurs across the Quran, and every ayah it is in.',
    lemmasTitle: 'Words from this root',
    lemmasHint: 'Click a word to see only its ayat.',
    allLemmas: 'All words',
    lemmaCol: 'Word',
    classCol: 'Kind',
    meaningCol: 'Meaning',
    countCol: 'Times',
    filtered: 'Showing only: {lemma}',
    clearFilter: 'Show the whole root',
    chartTitle: 'Across the 114 surahs',
    ayahsTitle: 'Ayat',
    back: 'All roots',
    notFound: 'This root does not occur in the Quran.',
    whatTitle: 'What is a root?',
    whatBody:
      'In Arabic the meaning lives in the root, usually three consonants, and vowels and additions build words around it. The root كتب gives kataba (he wrote), kitāb (book), kātib (scribe) and maktūb (written). Following a root shows how the Quran unfolds one idea through many words.',
    methodTitle: 'Source and method',
    methodBody:
      'The root, dictionary form and grammar of every word come from the Quranic Arabic Corpus (University of Leeds), in which each of the 77,429 words was annotated by hand. The meanings of roots and words were summarised by AI from the word-by-word meaning in each ayah; treat them as a guide, not a dictionary.',
    source: 'Grammar: Quranic Arabic Corpus 0.4, Kais Dukes, University of Leeds (GNU GPL), with corrections from mustafa0x/quran-morphology.',
    aiNote: 'Meanings summarised by AI',
    teaser: 'Almost every Arabic word grows from a three-letter root. Follow a root through the whole Quran: every word built from it, what each means, and every ayah.',
    cta: 'Explore the roots',
  },
  translations: {
    eyebrow: 'More translations',
    title: 'Translations side by side',
    hint: 'The same ayah in six translations. Pick one as the base to see where the others translate it differently.',
    compareWith: 'Mark the differences from',
    compareOff: 'No comparison',
    isBase: 'base of comparison',
    alike: '{n}% the same words',
    legendAdded: 'different',
    legendRemoved: 'left out',
    legendNote: 'Translations in the same language are compared, word by word.',
    footnote: 'Note {n}',
    notes: 'Translator’s notes ({n})',
    extra: 'More translations under each ayah',
    extraHint: 'Besides Korkut and Saheeh International, from QuranEnc.com.',
    lang: { bs: 'Bosnian', en: 'English', de: 'German', nl: 'Dutch', fr: 'French' },
    names: {
      'bubenheim': 'Bubenheim & Elyas (German)',
      'rowwad-de': 'Rowwad (German)',
      'rowwad-nl': 'Rowwad (Dutch)',
      rashid: 'Rachid Maach (French)',
      'noor-fr': 'Noor International (French)',
      korkut: 'Besim Korkut',
      mehanovic: 'Muhamed Mehanović',
      'rowwad-bs': 'Rowwad (Bosnian)',
      saheeh: 'Saheeh International',
      'hilali-khan': 'Hilali & Khan',
      'rowwad-en': 'Rowwad (English)',
    },
  },
  chronology: {
    nav: 'Chronology',
    eyebrow: 'Order of revelation',
    title: 'The Quran in the order it was revealed',
    subtitle:
      'The Quran was revealed gradually, over about 23 years, and the mushaf does not set its surahs in that order. Here they are as they came down: from the first ayat of Al-Alaq in Mecca to the last surahs in Medina.',
    factYears: 'years of revelation',
    factMeccan: 'Meccan surahs',
    factMedinan: 'Medinan surahs',
    timelineTitle: 'Every surah in the order of revelation',
    timelineHint: 'Each column is one surah, as tall as it is long in words. Click a column to open the surah.',
    timelineInsight:
      'The first surahs to be revealed are short, rhythmic and forceful. As revelation goes on they grow longer, and after the Hijra to Medina come the longest surahs, with the laws of a community.',
    barHint: 'Height = number of words',
    hijra: 'Hijra (622)',
    revealedNth: 'revealed {n}{suffix}',
    ayahs: 'Ayat',
    words: 'Words',
    ayahCount: '{n} ayat',
    chartLabel: 'Bar chart: the 114 surahs in the order of revelation; height is the number of words, colour the Meccan or Medinan period.',
    chartCaption: 'Surahs left to right in the order they were revealed; the dashed line is the Hijra.',
    compareTitle: 'Meccan and Medinan surahs',
    compareSubtitle: 'One Quran, two periods: thirteen years of calling people in Mecca and ten years of building a community in Medina. The difference shows in the numbers too.',
    metric: {
      surahs: 'Surahs',
      ayahs: 'Ayat',
      words: 'Words',
      wordsPerAyah: 'Words per ayah (mean)',
      ayahsPerSurah: 'Ayat per surah (mean)',
    },
    lengthInsight: 'A Meccan ayah has {meccan} words on average, a Medinan one {medinan}. The short, dense ayat of Mecca grow longer and more detailed in Medina, as they bring laws.',
    distinctive: {
      meccan: 'Characteristic of the Meccan surahs',
      medinan: 'Characteristic of the Medinan surahs',
    },
    distinctiveHint: 'Roots one period uses far more than the other. Numbers: Meccan · Medinan.',
    methodNote:
      'Method: the log-odds ratio with an informative Dirichlet prior (Monroe, Colaresi & Quinn, 2008), as a z-score. It measures not how common a word is but how unexpectedly common it is in one period, and is cautious with rare words. Roots from the Quranic Arabic Corpus.',
    listTitle: 'The surahs in the order of revelation',
    period: { meccan: 'Meccan period · 1–86', medinan: 'Medinan period · 87–114' },
    aboutTitle: 'About the order of revelation',
    about1:
      'The order is that of the standard Egyptian edition of the mushaf (al-Azhar, 1924), which draws on reports from the Companions and their students. It is the order most often cited, though not the only one: scholars differ on the place of some surahs, and some surahs hold ayat from both periods.',
    about2:
      'Surahs revealed before the Hijra count as Meccan and those after it as Medinan, wherever an ayah was revealed. The years are approximate: revelation began around 610, the Hijra was in 622 and the last ayat came in 632.',
    source: 'Sources: order of revelation and the Meccan / Medinan division, Tanzil Project (tanzil.net, CC BY 3.0); words and roots, Quranic Arabic Corpus 0.4 (corpus.quran.com).',
    teaser: 'The surahs in the order they were revealed, on a timeline, and how the Meccan and Medinan surahs differ: in length, in rhythm and in words.',
    cta: 'Open the chronology',
    mushafOrder: 'Mushaf order',
    revelationOrder: 'Order of revelation',
    orderLabel: 'Order of the surahs',
  },
  app: {
    available: 'Free on the',
    eyebrow: 'The Deenly app',
    title: 'Take the Quran with you',
    subtitle:
      'On the web you read and study. In the app the Quran lives with you: memorise with AI that listens to your recitation, listen offline and never lose your place.',
    features: [
      { icon: 'solar:microphone-3-linear', title: 'Hifz AI', body: 'Recite aloud and every word is marked right or wrong.' },
      { icon: 'solar:download-minimalistic-linear', title: 'Offline audio', body: 'Download surahs and listen anywhere.' },
      { icon: 'solar:bell-linear', title: 'Reminders', body: 'A gentle nudge morning and evening, with an ayah of the day.' },
      { icon: 'solar:cup-star-linear', title: 'Khatm & awards', body: 'A reading plan and milestones that keep you going.' },
    ],
  },
  footer: {
    title: 'The Quran on Deenly',
    body: 'The Quran is open to everyone, free and without an account. The text and translations come from the trusted sources listed below.',
    arabic: 'Arabic text',
    audio: 'Audio',
    bs: 'Bosnian translation',
    en: 'English translation',
    links: 'Links',
  },
};
